/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const AdminHome = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 30 30">
      <path fillRule="evenodd" clipRule="evenodd" d="M16.6139 5.21065C16.2528 4.92978 15.7472 4.92978 15.3861 5.21065L6.38606 12.2106C6.14247 12.4001 6 12.6914 6 13V24C6 24.7957 6.31607 25.5587 6.87868 26.1213C7.44129 26.6839 8.20435 27 9 27H13H19H23C23.7957 27 24.5587 26.6839 25.1213 26.1213C25.6839 25.5587 26 24.7957 26 24V13C26 12.6914 25.8575 12.4001 25.6139 12.2106L16.6139 5.21065ZM20 25H23C23.2652 25 23.5196 24.8946 23.7071 24.7071C23.8946 24.5196 24 24.2652 24 24V13.4891L16 7.26686L8 13.4891V24C8 24.2652 8.10536 24.5196 8.29289 24.7071C8.48043 24.8946 8.73478 25 9 25H12V16C12 15.4477 12.4477 15 13 15H19C19.5523 15 20 15.4477 20 16V25ZM14 25V17H18V25H14Z" />
    </BaseSvgIcon>
  )
}

export default AdminHome
